import styled, { css } from 'styled-components';

const monitorChatCss = () => css`
  > div:first-child {
    background-color: #0095E8;
    color: white;
  }
`;
export const Container = styled.div`
${({ monitorChatOnly }) => css`
  grid-area: chat;
  /* width: 100%;
  height: 100%; */
  z-index: 2;
  overflow: hidden;
  border-radius: 3px;
  border: 1px solid gray;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  -webkit-box-pack: justify;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  ${monitorChatOnly && monitorChatCss()}
`}
`;

export const BidActivityContainer = styled.div`
  background-color: #eee;
  height: 100%;
  overflow-y: scroll;
  font-size: 0.8em;
  line-height: 1.4em;
`;

export const Notification = styled.div`
  position: relative;
  clear: both;
  float: left;
  /* border-top: 0.5px solid rgb(230, 230, 230);
  border-bottom: 0.5px solid rgb(230, 230, 230); */
  font-size: 0.8em;
  width: 97%;
  padding: 5px 10px;
  color: #ff0000;
  & i {
    font-size: 1em;
    padding-right: 5px;
  }
`;

export const MessagesContainer = styled.div`
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  overflow-y: scroll;
  position: relative;
  width: 100%;
  border-bottom: 1px solid gray;
`;

export const Messages = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 101%;
  width: 100%;
  padding-top: 20px;
`;

export const Message = styled.div`
  grid-area: message;
  position: relative;
  clear: both;
  float: left;
  padding: 6px 10px 7px 5px;
  border-radius: 10px 10px 10px 0;
  background: #D7D8D8;
  margin: 12px 0px;
  font-size: 0.8em;
  line-height: 1.4;
  margin-left: 5px;
  @media (min-width: 1300px) {
    /* margin-left: 35px; */
  }
  width: 82%;
  &:last-child {
    margin-bottom: 30px;
  }
`;
